
const slider = document.querySelector('.slider');
const sliders = slider.querySelectorAll(`.slider__range`);
const planPriceHeading = slider.querySelector(`.plan__price`);
const planInternalValue = slider.querySelector(`#planInternalValue`);
const planExternalValue = slider.querySelector(`#planExternalValue`);
const planInternalRange = slider.querySelector(`#planInternalRange`);
const planExternalRange = slider.querySelector(`#planExternalRange`);
const planPrice = slider.querySelector(`#planPrice`);
const planPeriod = slider.querySelector(`#planPeriod`);
const monthSwitch = slider.querySelector(`#month`);
const yearSwitch = slider.querySelector(`#year`);

const plan = {
  internal: {
    min: 5,
    max: 500,
    perUser: 2,
    steps: [
      5, 10, 15, 20, 25, 30, 35, 40, 45, 50,
      60, 70, 80, 90, 100,
      120, 140, 160, 180, 200,
      250, 300, 350, 400, 450, 500
    ],
    isMax: false,
    total: 0,
  },
  external: {
    min: 100,
    max: 1000000,
    perUser: {
      // 100: 0,
      1000: 0.05,
      2000: 0.05,
      3000: 0.05,
      4000: 0.05,
      5000: 0.05,
      6000: 0.05,
      7000: 0.05,
      8000: 0.05,
      9000: 0.05,
      10000: 0.045,
      15000: 0.045,
      20000: 0.045,
      25000: 0.045,
      30000: 0.045,
      35000: 0.045,
      40000: 0.045,
      45000: 0.045,
      50000: 0.045,
      60000: 0.045,
      70000: 0.045,
      80000: 0.045,
      90000: 0.045,
      100000: 0.04,
      200000: 0.04,
      300000: 0.04,
      400000: 0.04,
      500000: 0.04,
      600000: 0.04,
      700000: 0.04,
      800000: 0.04,
      900000: 0.04,
      1000000: 0.035,
    },
    isMax: false,
    total: 0,
  },
  fobs: {
    min: 5,
    max: 500,
    perUser: 2,
    steps: [
      [5, 5],
      [60, 15],
      [150, 25],
      [300, 55],
    ],
    isMax: false,
    total: 0,
  },
  monthly: true,
  total: 0,
};

planInternalRange.setAttribute(`min`, 0);
planInternalRange.setAttribute(`max`, plan.internal.steps.length - 1);
planInternalRange.setAttribute(`value`, 0);
planInternalRange.setAttribute(`step`, 1);

planExternalRange.setAttribute(`min`, 0);
planExternalRange.setAttribute(`max`, Object.entries(plan.external.perUser).length - 1);
planExternalRange.setAttribute(`value`, 0);
planExternalRange.setAttribute(`step`, 1);

const countInternalPrice = (amount) => {
  if (amount <= 5) {
    return 0;
  }

  if (amount <= 100) {
    return (amount - 5) * 2.0;
  }

  if (amount <= 1000) {
    return (amount - 100) * 1.75 + countInternalPrice(100);
  }

  if (amount <= 10000) {
    return (amount - 1000) * 1.5 + countInternalPrice(1000);
  }
  
  if (amount <= 100000) {
    return (amount - 10000) * 1.0 + countInternalPrice(10000);
  }

  if (amount <= 1000000) {
    return (amount - 100000) * 0.75 + countInternalPrice(100000);
  }

  return (amount - 1000000) * 0.5 + countInternalPrice(1000000);
}
/*
const countExternalPrice = (amount) => {
  if (amount <= 100) {
    return 0;
  }

  if (amount <= 1000) {
    return (amount - 100) * 0.05;
  }

  if (amount <= 10000) {
    return (amount - 1000) * 0.045 + countExternalPrice(1000);
  }

  if (amount <= 100000) {
    return (amount - 10000) * 0.04 + countExternalPrice(10000);
  }
  
  if (amount <= 1000000) {
    return (amount - 100000) * 0.035 + countExternalPrice(100000);
  }

  if (amount <= 100000000) {
    return (amount - 1000000) * 0.03 + countExternalPrice(1000000);
  }

  return (amount - 100000000) * 0.02 + countExternalPrice(100000000);
};
*/

const countExternalPrice = (amount) => {
  const STEP_1K = 1000;
  const STEP_10K = 10000;
  const STEP_100K = 100000;
  const STEP_1M = 1000000; 
  const STEP_1B = 1000000000;
  const STEP_1T = 1000000000000;

  const step = {
    STEP_10K: 0.05,
    STEP_100K: 0.045,
    STEP_1M: 0.04,
    STEP_1B: 0.035,
    STEP_1T: 0.03
  };

  if (amount <= STEP_1K) {
    return 0; // freedom!
  }

  if (amount <= STEP_10K) {
    return (amount - STEP_1K) * step.STEP_10K;
  }

  if (amount <= STEP_100K) {
    return (amount - STEP_10K) * step.STEP_100K + countExternalPrice(STEP_10K);
  }

  if (amount <= STEP_1M) {
    return (amount - STEP_10K) * step.STEP_1M + countExternalPrice(STEP_10K);
  }
  
  if (amount <= STEP_1B) {
    return (amount - STEP_1M) * step.STEP_1B + countExternalPrice(STEP_1M);
  }

  return (amount - STEP_1B) * step.STEP_1T + countExternalPrice(STEP_1B);
};

const planPriceLayout = () => {
  plan.total = plan.internal.total + plan.external.total + plan.fobs.total;
  if (!plan.monthly) {
    // plan.total *= 10;
    planPriceHeading.innerHTML = `$<span id="planPrice">${ Math.floor(plan.total) * 10}</span>/<span id="planPeriod">yr</span>`;
    return;
  }
  planPriceHeading.innerHTML = `$<span id="planPrice">${ Math.floor(plan.total) }</span>/<span id="planPeriod">mo</span>`;
};

const setInternalPrice = (intValue) => {
  plan.internal.isMax = false;
  if (plan.internal.steps[intValue] === plan.internal.max) {
    plan.internal.isMax = true;
  }
  if (intValue > 0) {
    plan.internal.total = countInternalPrice(plan.internal.steps[intValue]);
  }
  else {
    plan.internal.total = 0;
  }
  planPriceLayout();
};

const setExternalPrice = (extValue) => {
  plan.external.isMax = false;
  if (parseInt(Object.entries(plan.external.perUser)[extValue][0]) === plan.external.max) {
    plan.external.isMax = true;
  }
  if (extValue > 0) {
    plan.external.total = countExternalPrice(parseInt(Object.entries(plan.external.perUser)[extValue][0]));
  }
  else {
    plan.external.total = 0;
  }
  planPriceLayout();
};

const setPrice = (internal, external, fobs) => {
  setInternalPrice(internal);
  setExternalPrice(external);
  planPriceLayout();
};

const fillSliderRange = (slider) => {
  const fillPercent = slider.value / slider.getAttribute(`max`) * 100;
  slider.style.background = `linear-gradient(to right, #2e75e6, #2e75e6 ${fillPercent}%, #bad9fa ${fillPercent}%, #bad9fa)`;
};

const onSliderChange = (slider) => {
  slider.setAttribute(`value`, slider.value)
  fillSliderRange(slider);
  if (slider.id === `planInternalRange`) {
    planInternalValue.innerText = plan.internal.steps[slider.value]
  }
  if (slider.id === `planExternalRange`) {
    planExternalValue.innerText = Object.entries(plan.external.perUser)[slider.value][0];
  }
  setPrice(planInternalRange.value, planExternalRange.value);
};

if (sliders) {
  sliders.forEach((slider) => {
    
    onSliderChange(slider);

    slider.addEventListener(`input`, () => {
        onSliderChange(slider);
      });
  });
}

monthSwitch.addEventListener(`change`, () => {
  
  plan.monthly = true;
  setPrice(planInternalRange.value, planExternalRange.value);
});

yearSwitch.addEventListener(`change`, () => {
  
  plan.monthly = false;
  setPrice(planInternalRange.value, planExternalRange.value);
});
